import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  FormGroup,
  Field,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup
} from '@availity/form';
import { DateField } from '@availity/date';
import { SelectField } from '@availity/select';
import { Row, Col, Button, Label } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class HousingAssessment extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToRiskFactors: false,
      redirectToStrengths: false,
      redirectToLandingPage: false,
    }
    
    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    if (housingstore.getSupportiveHousingRouteStatus('/riskfactors') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/housingassessment') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/housingassessment') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/housingassessment', 'active');
    }
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.navigate(1); 
    }
  }

  selectEmploymentStatus = value => {
    housingstore.setEmploymentCategories(value);
  }

  selectIncomeSource = value => {
    housingstore.setIncomeCategories(value); 
  }

  setOtherDetails = event => {
    const { value } = event.target;
    housingstore.setIncomeOther(value);
  }

  setTotalIncome = value => {
    housingstore.setTotalIncome(value);
  }

  setIsClientHoused = value => {
    housingstore.setIsClientHoused(value);
    
    if (value === 'Yes') {
      housingstore.setHomelessRadio('');
      housingstore.setHomelessOther('');
    } else if (value === 'No') {
      housingstore.setDateHoused('');
      housingstore.setCurrentHousingType('');
      housingstore.setCurrentHousingTypeOther('');
      housingstore.setHousingAtRisk('');
      housingstore.setHousingAtRiskReasons([]);
      housingstore.setHousingAtRiskOther('');
    }
  }

  setDateHoused = value => {
    housingstore.setDateHoused(value);
  }

  setHousingType = value => {
    housingstore.setHousingType(value);
  }

  selectHomelessType = value => {
    housingstore.setHomelessRadio(value);
  }

  setHomelessOther = event => {
    const { value } = event.target;
    housingstore.setHomelessOther(value);
  }

  setCurrentHousingType = value => {
    housingstore.setCurrentHousingType(value);
    
    if (value !== 'Other') {
      housingstore.setCurrentHousingTypeOther('');
    }
  }

  setCurrentHousingTypeOther = event => {
    const { value } = event.target;
    housingstore.setCurrentHousingTypeOther(value);
  }

  setHousingAtRisk = value => {
    housingstore.setHousingAtRisk(value);
    
    if (value === 'No') {
      housingstore.setHousingAtRiskReasons([]);
      housingstore.setHousingAtRiskOther('');
    }
  }

  setHousingAtRiskReasons = value => {
    housingstore.setHousingAtRiskReasons(value);
  }

  setHousingAtRiskOther = event => {
    const { value } = event.target;
    housingstore.setHousingAtRiskOther(value);
  }

  goBack = () => {
    housingstore.setSupportiveHousingPageStatus('#healthneeds', 'active');
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'disabled');
    housingstore.setSupportiveHousingRouteStatus('/riskfactors', 'active');
    housingstore.setSupportiveHousingRouteStatus('/housingassessment', 'inactive');
    this.setState({redirectToRiskFactors: true});
  }

  submit = (pendingRoute = '/strengths') => {
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingstore.setSupportiveHousingRouteStatus('/housingassessment', 'completed');
    if (pendingRoute === '/strengths') {
      this.setState({redirectToStrengths: true});
      return;
    }
    this.props.navigate(pendingRoute);
  }
  
  render() {

    const { redirectToRiskFactors, redirectToStrengths, redirectToLandingPage } = this.state;

    const {
      employmentCategories,
      incomeCategories,
      incomeOther,
      homelessRadio,
      homelessOther,
      totalIncome,
      housingType,
      isClientHoused,
      dateHoused,
      currentHousingType,
      currentHousingTypeOther,
      housingAtRisk,
      housingAtRiskReasons,
      housingAtRiskOther,
      supportiveHousingPagesAHAH,
      supportiveHousingPagesNoAHAH,
      memberInfo
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToRiskFactors) {
      return <Navigate to="/riskfactors" />
    }

    if(redirectToStrengths) {
      return <Navigate to="/strengths" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return (
      <>    
        <div className="border-form">
          <div className="spacer-50" />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              employmentCheck: employmentCategories.map(x => x),
              incomeCheck: incomeCategories.map(x => x),
              otherDetails: incomeOther,
              totalIncRadio: totalIncome,
              isClientHousedRadio: isClientHoused,
              dateHousedField: dateHoused,
              homelessRadio: homelessRadio,
              homelessDetails: homelessOther,
              currentHousingTypeRadio: currentHousingType,
              currentHousingTypeOtherField: currentHousingTypeOther,
              housingAtRiskRadio: housingAtRisk,
              housingAtRiskReasonsCheck: housingAtRiskReasons.map(x => x),
              housingAtRiskOtherField: housingAtRiskOther,
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              employmentCheck: yup.array().isRequired(true, 'Please select an option before continuing!'),
              incomeCheck: yup.array().isRequired(true, 'Please select an option before continuing!'),
              otherDetails: yup.string().isRequired(incomeCategories.indexOf('Other') >= 0,'Please enter information!'),
              totalIncRadio: yup.string().required('Please select an option before continuing!'),
              isClientHousedRadio: yup.string().required('Please select an option before continuing!'),
              dateHousedField: yup.date()
                .max(new Date(), 'Date cannot be in the future')
                .nullable()
                .test('is-required-when-yes', 'Date housed is required', function(value) {
                  const { isClientHousedRadio } = this.parent;
                  if (isClientHousedRadio === 'Yes' && !value) {
                    return false;
                  }
                  return true;
                })
                .typeError('Please select the date of housing'),
              homelessRadio: yup.string().isRequired(isClientHoused === 'No', 'Please select an option before continuing!'),
              homelessDetails: yup.string().isRequired((isClientHoused === 'No' && homelessRadio === 'Other'), 'Please enter information!'),
              currentHousingTypeRadio: yup.string().when('isClientHousedRadio', {
                is: 'Yes',
                then: yup.string().required('Please select housing type'),
              }),
              currentHousingTypeOtherField: yup.string().isRequired(currentHousingType === 'Other', 'Please enter housing type details'),
              housingAtRiskRadio: yup.string().when('isClientHousedRadio', {
                is: 'Yes',
                then: yup.string().required('Please select an option'),
              }),
              housingAtRiskReasonsCheck: yup.array().when('housingAtRiskRadio', {
                is: 'Yes',
                then: yup.array().min(1, 'Please select at least one reason'),
              }),
              housingAtRiskOtherField: yup.string().isRequired(housingAtRiskReasons.indexOf('Other') >= 0, 'Please enter details'),
            })}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
              Housing Assessment
            </h2>
            <em>
              <small className="label-font">Please fill out to the best of your ability. This information is required but does not impact eligibility.</small>
            </em>
            <div className="spacer" />
            
            <div>
              <div className="d-flex">
                <h5 className="poppinsH5 mbrem-1">
                  Employment status* &nbsp;
                </h5>
              </div>
              <Row>
                <CheckboxGroup name="employmentCheck" value={employmentCategories} onChange={this.selectEmploymentStatus}>
                  <Row sm="12">
                    <Col className="employmentCol mrn-1halfrem" sm="4">
                      <Checkbox className="label-font mb-5 no-display" name="opt1" label="Unemployed" value="Unemployed" />
                      <Checkbox className="label-font mb-5 no-display" name="opt2" label="Employed part time" value="Employed part time" />
                      <Checkbox className="label-font mb-5 no-display" name="opt3" label="Employed full time" value="Employed full time" />
                    </Col>
                    <Col className="employmentCol" sm="4">
                      <Checkbox className="label-font mb-5 no-display" name="opt4" label="Nonpaid employment activities" value="Nonpaid employment activities" />
                      <Checkbox className="label-font mb-5 no-display" name="opt5" label="Enrolled in training/education program" value="Enrolled in training/education program" /> 
                    </Col>
                  </Row>
                </CheckboxGroup>
              </Row>
            </div>
            <hr className="mtb-32" />
            <div>
              <h5 className="poppinsH5 mbrem-1">
                Income source*
              </h5>
              <Row>
                <Col>
                  <CheckboxGroup name="incomeCheck" value={incomeCategories} className={incomeCategories.indexOf('Other') >= 0 ? "noMargin-buttom" : ""} onChange={this.selectIncomeSource}>
                    <Row sm="12">
                      <Col className="incomeSourceCol mr-2rem" sm="3">
                        <Checkbox className="label-font mb-5 no-display" name="opt1" label="Social Security (SSA)" value="Social Security (SSA)" />
                        <Checkbox className="label-font mb-5 no-display" name="opt2" label="Pension" value="Pension" />
                        <Checkbox className="label-font mb-5 no-display" name="opt3" label="Supplemental Security Income (SSI)" value="Supplemental Security Income (SSI)" />
                      </Col>
                      <Col className="incomeSourceCol" sm="4">
                        <Checkbox className="label-font mb-5 no-display" name="opt4" label="Social Security Disability Insurance (SSDI)" value="Social Security Disability Insurance (SSDI)" />
                        <Checkbox className="label-font mb-5 no-display" name="opt5" label="Temporary Assistance for Needy Families (TANF)" value="Temporary Assistance for Needy Families (TANF)" />
                        <Checkbox className="label-font mb-5 no-display" name="opt6" label="Housing and Essential Needs (HEN)" value="Housing and Essential Needs (HEN)" />
                      </Col>
                      <Col className="incomeSourceCol" sm="4">
                        <Checkbox className="label-font mb-5 no-display" name="opt7" label="Aged, Blind, or Disabled (ABD)" value="Aged, Blind, or Disabled (ABD)" />
                        <Checkbox className="label-font mb-5 no-display" name="opt8" label="Employment" value="Employment" />
                        <Checkbox className="label-font mb-2 no-display" name="opt10" label="None" value="None" />
                        <Checkbox className="label-font mb-2 no-display" name="opt9" label="Other:" value="Other" />
                        {incomeCategories.indexOf('Other') >= 0 && (
                          <FormGroup className="noMargin-buttom mt-2" for="otherDetails">
                            <Field
                              type="textarea"
                              id="otherDetails"
                              name="otherDetails"
                              className="noMargin-buttom custom-OtherTextArea straighten-borders form-control form-group"
                              onChange={this.setOtherDetails}
                              value={incomeOther}
                              row="3"
                              col="200"
                              maxLength={200}
                              required
                            />
                            <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>
                  </CheckboxGroup>
                  </Col>
                </Row>
            </div>
            <hr className="mtb-32" />
            <div>
              <h5 className="poppinsH5 mbrem-1">
                Total income*
              </h5>
              <RadioGroup name="totalIncRadio" value={totalIncome} onChange={this.setTotalIncome}>
                <Row>
                  <Col className="incomeColumn" sm="4">
                    <Radio className="label-font-round totalIncRadioOpt" label="Less than $10,000" value="Less than $10,000" />
                    <Radio className="label-font-round totalIncRadioOpt" label="$10,000 to $14,999" value="$10,000 to $14,999" />
                    <Radio className="label-font-round totalIncRadioOpt" label="$15,000 to $19,999" value="$15,000 to $19,999" />
                  </Col>
                  <Col className="incomeColumn" sm="4">
                    <Radio className="label-font-round totalIncRadioOpt" label="$20,000 to $24,999" value="$20,000 to $24,999" />
                    <Radio className="label-font-round totalIncRadioOpt" label="$25,000 to $29,999" value="$25,000 to $29,999" />
                    <Radio className="label-font-round totalIncRadioOpt" label="$30,000 to $34,999" value="$30,000 to $34,999" />
                  </Col>
                  <Col className="incomeColumn" sm="4">
                    <Radio className="label-font-round totalIncRadioOpt" customInput label="$35,000 or more" value="$35,000 or more" onChange={this.setTotalIncome} />  
                  </Col>
                </Row>
              </RadioGroup>
            </div>
            <hr className="mtb-32" />
            <div>
              <h5 className="poppinsH5 mbrem-1">
                Housing*
              </h5>
              <Row>
                <Col>
                  <Label className="label-font">Is the client housed?*</Label>
                  <RadioGroup name="isClientHousedRadio" value={isClientHoused} onChange={this.setIsClientHoused}>
                    <Radio className="label-font-round totalIncRadioOpt" label="Yes" value="Yes" />
                    <Radio className="label-font-round totalIncRadioOpt" label="No" value="No" />
                  </RadioGroup>

                  {isClientHoused === 'Yes' && (
                    <>
                      <Row className="mt-3">
                        <Col sm="4">
                          <FormGroup for="dateHousedField" className="label-font">
                            <DateField
                              id="dateHousedField"
                              name="dateHousedField"
                              label="What date did they get housed?*"
                              className="straighten-borders"
                              value={dateHoused}
                              onChange={this.setDateHoused}
                              datePickerProps={{
                                showDefaultInputIcon: true,
                                inputIconPosition: 'after',
                                autoComplete: 'off',
                                phrases: {
                                  focusStartDate: 'Select date housed'
                                }
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col>
                          <Label className="label-font">What type of housing does the client currently live in?*</Label>
                          <RadioGroup name="currentHousingTypeRadio" value={currentHousingType} onChange={this.setCurrentHousingType}>
                            <Row>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Project based (Services available on site)" value="Project based (Services available on site)" />
                              </Col>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Recovery residence or sober living" value="Recovery residence or sober living" />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Scattered site" value="Scattered site" />
                              </Col>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Single room occupancy" value="Single room occupancy" />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Transitional program" value="Transitional program" />
                              </Col>
                              <Col sm="8">
                                <Radio className="label-font-round mb-2" label="Shared living/living with roommate(s) – market rate" value="Shared living/living with roommate(s) – market rate" />
                              </Col>
                            </Row>
                            <Row>
                              <Col sm="4">
                                <Radio className="label-font-round mb-2" label="Other:" value="Other" />
                                {currentHousingType === 'Other' && (
                                  <FormGroup for="currentHousingTypeOtherField">
                                    <Field
                                      type="textarea"
                                      id="currentHousingTypeOtherField"
                                      name="currentHousingTypeOtherField"
                                      className="straighten-borders form-control custom-OtherTextArea"
                                      onChange={this.setCurrentHousingTypeOther}
                                      value={currentHousingTypeOther}
                                      row="3"
                                      col="200"
                                      maxLength={200}
                                    />
                                    <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                                  </FormGroup>
                                )}
                              </Col>
                            </Row>
                          </RadioGroup>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col>
                          <Label className="label-font">Is the client's current housing at risk?*</Label>
                          <RadioGroup name="housingAtRiskRadio" value={housingAtRisk} onChange={this.setHousingAtRisk}>
                            <Radio className="label-font-round" label="Yes" value="Yes" />
                            <Radio className="label-font-round" label="No" value="No" />
                          </RadioGroup>

                          {housingAtRisk === 'Yes' && (
                            <>
                              <Row className="mt-2">
                                <Col>
                                  <Label className="label-font">Select the most appropriate reason(s):*</Label>
                                  <CheckboxGroup name="housingAtRiskReasonsCheck" value={housingAtRiskReasons} onChange={this.setHousingAtRiskReasons}>
                                    <Row>
                                      <Col sm="4">
                                        <Checkbox className="label-font mb-2 no-display" label="Lease violations" value="Lease violations" />
                                      </Col>
                                      <Col sm="4">
                                        <Checkbox className="label-font mb-2 no-display" label="Issues with rent and/or other payments" value="Issues with rent and/or other payments" />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col sm="4">
                                        <Checkbox className="label-font mb-2 no-display" label="Habitability issues" value="Habitability issues" />
                                      </Col>
                                      <Col sm="4">
                                        <Checkbox className="label-font mb-2 no-display" label="Landlord issues" value="Landlord issues" />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col sm="4">
                                        <Checkbox className="label-font mb-2 no-display" label="Other:" value="Other" />
                                        {housingAtRiskReasons.indexOf('Other') >= 0 && (
                                          <FormGroup for="housingAtRiskOtherField" className="mt-2">
                                            <Field
                                              type="textarea"
                                              id="housingAtRiskOtherField"
                                              name="housingAtRiskOtherField"
                                              className="straighten-borders form-control custom-OtherTextArea"
                                              onChange={this.setHousingAtRiskOther}
                                              value={housingAtRiskOther}
                                              row="3"
                                              col="200"
                                              maxLength={200}
                                            />
                                            <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                                          </FormGroup>
                                        )}
                                      </Col>
                                    </Row>
                                  </CheckboxGroup>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}

                  {isClientHoused === 'No' && (
                    <>
                      <h5 className="homeless-label">
                        <b>* If homeless, choose type:</b>
                      </h5>
                      <RadioGroup name="homelessRadio" value={homelessRadio} onChange={this.selectHomelessType}>
                        <Row>
                          <Col sm="4">
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="Living in a place not meant for human habitation (for example, car)"
                              value="Living in a place not meant for human habitation (for example, car)" />
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="In an emergency shelter" value="In an emergency shelter" />
                            <Radio className="label-font mb-2 no-display homelessRadioOpt" label="Other:" value="Other" />
                            {homelessRadio === 'Other' && (
                              <FormGroup className="noMargin-buttom mt-2" for="homelessDetails">
                                <Field
                                  type="textarea"
                                  id="homelessDetails"
                                  name="homelessDetails"
                                  className="noMargin-buttom custom-OtherTextArea straighten-borders form-control form-group"
                                  onChange={this.setHomelessOther}
                                  value={homelessOther}
                                  row="3"
                                  col="200"
                                  maxLength={200}
                                />
                                <p className="small text-right mb-0 label-font character-limit">200 Character max</p>
                              </FormGroup>
                            )}
                          </Col>
                          <Col sm="4">
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="Evicted or foreclosure within 30 days with no future residence identified"
                              value="Evicted or foreclosure within 30 days with no future residence identified" />
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="At imminent risk of losing housing" value="At imminent risk of losing housing" />
                          </Col>
                          <Col sm="4">
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="Homeless but admitted to a hospital or other institution for less than 30 days"
                              value="Homeless but admitted to a hospital or other institution for less than 30 days" />
                            <Radio className="label-font mb-5 no-display homelessRadioOpt" label="Couch surfing or doubled up" value="Couch surfing or doubled up" />
                          </Col>
                        </Row>
                      </RadioGroup>
                    </>
                  )}
                </Col>
              </Row>  
            </div>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(HousingAssessment);

HousingAssessment.propTypes = {
  navigate: PropTypes.func
};